function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import PaginationVue from '@/components/PaginationVue.vue';
import CreateAttributeForm from '@/apps/attributes/modules/use_cases/components/CreateAttributeForm.vue';
import CreateAttributeDetail from '@/apps/attributes/modules/use_cases/CreateAttributeDetail.vue';
import ActivityTimelineDialog from '@/apps/attributes/modules/use_cases/components/ActivityTimelineDialog.vue';
import EditScriptDialog from '@/apps/attributes/modules/use_cases/components/EditScriptDialog.vue';
import PartitionValidationErrors from '@/apps/attributes/modules/use_cases/components/PartitionValidationErrors.vue';
import ShareAutomationComponent from '@/apps/attributes/modules/use_cases/components/ShareAutomationComponent.vue';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import { filterMixin } from '@/mixins/filter_mixin';
import { localPaginationMixin } from '@/mixins/local_pagination';
import { mapState, mapMutations } from 'vuex';
import tasks from '@/js/tasks';
import { ORGS } from '@/js/constants';
var INTERBANK_COMPANY_CODE = '000';
// Empresa cuyos ATTRIBUTE_ADMIN gestionan el universo de automatizaciones.
// Gatea "Cambiar estado"; el hard delete ya NO lo usa (ver canHardDelete).
var INTERCORP_COMPANY_CODE = '032';
var MAX_LOAD_MONTH_PERIODS = 12;

// Agrupación del preview de hard delete por severidad del recurso. Las claves son los
// `step` que devuelve hard_delete_preview_service del backend; si aparece uno nuevo cae
// en "platform" (auditable) en vez de desaparecer de la vista.
//   data     → se borra y no se recupera (BigQuery, S3/GCS, Glue, Athena, DynamoDB)
//   runs     → ejecuciones vivas que se cancelan (Step Functions, Glue)
//   platform → registros INCA, reversibles o auditables (PG, Typesense, aprobación)
// Los pasos con would_act=false se reagrupan en "untouched" en tiempo de render.
var HD_STEP_GROUPS = {
  stepfunctions_stop: 'runs',
  glue_runs_stop: 'runs',
  dynamodb_dedupe_delete: 'data',
  s3_lambda_cache_delete: 'data',
  s3_pending_script_delete: 'data',
  glue_get_table_location: 'data',
  s3_parquet_delete: 'data',
  glue_delete_table: 'data',
  athena_staging_drop: 'data',
  bq_drop_final: 'data',
  bq_drop_temps: 'data',
  gcs_scripts_delete: 'data',
  gcs_parquet_delete_v2: 'data',
  dataplex_metadata_delete: 'platform',
  approval_flow_cancel: 'platform',
  typesense_disable_category: 'platform',
  pg_purge_children: 'platform',
  attribute_group_delete: 'platform'
};
// Pasos que se pueden omitir en un reintento: lo que dejan atrás es auditable o se limpia
// a mano sin riesgo. Omitir Glue, S3, BigQuery o la purga en la base dejaría el atributo
// ELIMINADO con datos vivos (misma lista blanca que SP-6 en el backend).
var HD_SKIPPABLE_STEPS = ['dataplex_metadata_delete', 'typesense_disable_category', 'approval_flow_cancel'];
// Avisos del preview que son de configuración del ambiente, no del atributo.
var HD_ENV_WARNINGS = ['ENV_DATAMNGT_MISSING', 'ENV_S3_OUTPUT_MISSING'];
// Cada cuánto se consulta deletion-status mientras corre el DELETE.
var HD_POLL_MS = 2500;

// Espejo de StatusTransitionValidator.MANUAL_ALLOWED del backend (RN-ATTR-024). Se replica
// aquí solo para no ofrecer opciones que el backend va a rechazar con 409; la validación
// real vive en el backend. Si allí cambia el mapa, hay que actualizar este.
var MANUAL_STATUS_TRANSITIONS = {
  // Error → En ejecución, Ejecutado
  2: [12, 14],
  // En ejecución → Error, Ejecutado
  12: [2, 14],
  // Ejecutado → Error, En ejecución
  14: [2, 12]
};
export default {
  name: 'CreateAttributePage',
  components: {
    DialogsComponent: DialogsComponent,
    DialogConfirmationComponent: DialogConfirmationComponent,
    PaginationVue: PaginationVue,
    CreateAttributeForm: CreateAttributeForm,
    CreateAttributeDetail: CreateAttributeDetail,
    ActivityTimelineDialog: ActivityTimelineDialog,
    EditScriptDialog: EditScriptDialog,
    PartitionValidationErrors: PartitionValidationErrors,
    ShareAutomationComponent: ShareAutomationComponent
  },
  mixins: [filterMixin, localPaginationMixin],
  data: function data() {
    return {
      createFormStep: 1,
      createFormValid: false,
      // Fase 7: bloquea el botón Save mientras el form está enviando para evitar
      // doble-click que crearia dos automatizaciones gemelas.
      formSending: false,
      DIALOG_CREATE: 'DIALOG_CREATE',
      DIALOG_DETAIL: 'DIALOG_DETAIL',
      DIALOG_LOAD_MONTHS: 'DIALOG_LOAD_MONTHS',
      DIALOG_HARD_DELETE: 'DIALOG_HARD_DELETE',
      DIALOG_CHANGE_STATUS: 'DIALOG_CHANGE_STATUS',
      DIALOG_SENT_TO_REVIEW: 'DIALOG_SENT_TO_REVIEW',
      changeStatusTarget: null,
      changeStatusNewStatus: null,
      changeStatusReason: '',
      changeStatusSending: false,
      sentReviewValidation: null,
      // Borrado definitivo v2: estado del diálogo DIALOG_HARD_DELETE.
      hardDeleteTarget: null,
      // automate_id de la fila que abrió el diálogo: al cerrar se devuelve el foco a su ⋮.
      hardDeleteOpenerId: null,
      hardDeleteReason: '',
      // Fricción extra para una acción irreversible: el admin teclea el nombre
      // exacto de la tabla, para que un click en la fila equivocada no baste.
      hardDeleteConfirmName: '',
      // force=true para el backend: detener la carga en curso. Nunca llega pre-marcado.
      hardDeleteForce: false,
      // El backend respondió FORCE_REQUIRED: la fila empezó a cargar después de abrir.
      hardDeleteForceRequired: false,
      hardDeleteAckConsumers: false,
      hardDeleteSending: false,
      hardDeleteTouched: {
        reason: false,
        name: false
      },
      // Preview (GET hard-delete-preview). `hardDeletePreviewError` guarda el motivo del
      // fallo; tras dos fallos se permite seguir con confirmación explícita.
      hardDeletePreview: [],
      hardDeleteWarningsDetail: [],
      hardDeleteConsumers: {
        count: 0,
        items: [],
        error: null
      },
      hardDeleteCategorySiblings: [],
      hardDeletePreviewLoading: false,
      hardDeletePreviewError: '',
      hardDeletePreviewFails: 0,
      hardDeletePreviewAck: false,
      // Checklist de reintento tras un 207: pasos del último intento + selección de saltos.
      hardDeleteSteps: [],
      hardDeleteResumeFrom: null,
      hardDeleteSkipSteps: [],
      // Progreso del intento en curso (deletion-status.in_progress) mientras corre el DELETE.
      hardDeleteProgress: null,
      hardDeletePollTimer: null,
      hardDeletePollBusy: false,
      // Resultado visible del último envío: { kind, tone, title, text, action }.
      hardDeleteOutcome: null,
      hardDeleteLiveMessage: '',
      hardDeleteOpenDetails: [],
      filter_enabled: true,
      isLoading: false,
      sortBy: 'fecha_creacion',
      sortDesc: true,
      dateMenu: false,
      selectedItem: {},
      createdAutomationItem: null,
      loadMonthsAutomationItem: null,
      itemToDeactivate: null,
      loadMonthsSending: false,
      maxLoadMonthPeriods: MAX_LOAD_MONTH_PERIODS,
      selectedLoadMonth: null,
      selectedLoadYear: null,
      selectedPeriods: [],
      existingTableNames: [],
      filters: {
        empresa: '',
        estado: '',
        use_case: '',
        fecha: '',
        nombre_tabla: ''
      },
      statusCatalog: null,
      items: [],
      months: [{
        name: 'Enero',
        value: '01'
      }, {
        name: 'Febrero',
        value: '02'
      }, {
        name: 'Marzo',
        value: '03'
      }, {
        name: 'Abril',
        value: '04'
      }, {
        name: 'Mayo',
        value: '05'
      }, {
        name: 'Junio',
        value: '06'
      }, {
        name: 'Julio',
        value: '07'
      }, {
        name: 'Agosto',
        value: '08'
      }, {
        name: 'Septiembre',
        value: '09'
      }, {
        name: 'Octubre',
        value: '10'
      }, {
        name: 'Noviembre',
        value: '11'
      }, {
        name: 'Diciembre',
        value: '12'
      }]
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['labelCatalog'])), {}, {
    isAdmin: function isAdmin() {
      var roles = window.userInfo && window.userInfo.userRoles || [];
      return roles.includes('attribute_admin');
    },
    // Fase 4: gating del modo "Todas (admin)" + acción Hard Delete.
    // Restringido a ATTRIBUTE_ADMIN con email del dominio @intercorp.com.pe
    // (los admins internos Intercorp gestionan el universo; externos no).
    isIntercorpAdmin: function isIntercorpAdmin() {
      if (!this.isAdmin) return false;
      var code = this.companyCode === null || this.companyCode === undefined ? '' : String(this.companyCode).trim();
      return code.padStart(3, '0') === INTERCORP_COMPANY_CODE;
    },
    // El backend valida unicamente el rol attribute_admin contra Firestore
    // (hard_delete_automation_service.py:649). El gating de UI se alinea con esa
    // regla: restringirlo ademas por companyCode daba una sensacion de proteccion
    // que el endpoint no aplicaba, y ocultaba la accion a admins que si pueden
    // ejecutarla por API. `isIntercorpAdmin` se mantiene para "Cambiar estado".
    canHardDelete: function canHardDelete() {
      return this.isAdmin;
    },
    isInterbankProfile: function isInterbankProfile() {
      var code = this.companyCode === null || this.companyCode === undefined ? '' : String(this.companyCode).trim();
      var isInterbankCode = !!code && code.padStart(3, '0') === INTERBANK_COMPANY_CODE;
      return isInterbankCode || String(this.companyName || '').toLowerCase() === 'interbank';
    },
    canCreateAutomation: function canCreateAutomation() {
      return this.isInterbankProfile;
    },
    headers: function headers() {
      var cols = [{
        text: this.$t('create_attribute.table.use_case'),
        value: 'caso_de_uso'
      }, {
        text: this.$t('create_attribute.table.table_name'),
        value: 'nombre_tabla'
      }];
      cols.push({
        text: this.$t('create_attribute.table.owner'),
        value: 'owner_name'
      });
      if (this.isAdmin) {
        cols.push({
          text: this.$t('create_attribute.table.company'),
          value: 'company_name'
        });
      }
      cols.push({
        text: this.$t('create_attribute.table.status'),
        value: 'estado'
      });
      cols.push({
        text: "".concat(this.$t('create_attribute.table.created_date')),
        value: 'fecha_creacion'
      });
      cols.push({
        text: '',
        value: 'action',
        sortable: false
      });
      return cols;
    },
    // Destinos ofrecidos en el selector, con la etiqueta del catálogo de estados
    // (getStatus ya cae al mapa canónico si el catálogo del backend no cargó).
    changeStatusOptions: function changeStatusOptions() {
      var _this = this;
      if (!this.changeStatusTarget) return [];
      return this.allowedStatusTargets(this.changeStatusTarget.estado).map(function (id) {
        return {
          value: id,
          text: _this.getStatus(id).text
        };
      });
    },
    changeStatusReasonRules: function changeStatusReasonRules() {
      var _this2 = this;
      return [function (v) {
        return !!v || _this2.$t('create_attribute.change_status.reason_required');
      }, function (v) {
        return v && v.trim().length >= 10 || _this2.$t('create_attribute.change_status.reason_min');
      }, function (v) {
        return !v || v.length <= 500 || _this2.$t('create_attribute.change_status.reason_max');
      }];
    },
    canConfirmChangeStatus: function canConfirmChangeStatus() {
      var reason = (this.changeStatusReason || '').trim();
      if (reason.length < 10 || reason.length > 500) return false;
      if (!this.changeStatusNewStatus) return false;
      // El destino debe seguir siendo válido para el estado actual de la fila.
      if (!this.changeStatusTarget) return false;
      return this.allowedStatusTargets(this.changeStatusTarget.estado).includes(Number(this.changeStatusNewStatus));
    },
    // ── Borrado definitivo v2 ──────────────────────────────────────────────
    hardDeleteTargetName: function hardDeleteTargetName() {
      return this.hardDeleteTarget && this.hardDeleteTarget.nombre_tabla || '';
    },
    hardDeleteMetaText: function hardDeleteMetaText() {
      var target = this.hardDeleteTarget;
      if (!target) return '';
      return this.$t('create_attribute.hard_delete.meta', {
        use_case: target.caso_de_uso || '-',
        status: this.getStatus(target.estado).text,
        id: target.automate_id
      });
    },
    // Pasos del preview que efectivamente borrarían algo, separados por severidad.
    hardDeleteActionableSteps: function hardDeleteActionableSteps() {
      return (this.hardDeletePreview || []).filter(function (p) {
        return p && p.would_act;
      });
    },
    hardDeleteDataSteps: function hardDeleteDataSteps() {
      return this.hardDeleteActionableSteps.filter(function (p) {
        return (HD_STEP_GROUPS[p.step] || 'platform') === 'data';
      });
    },
    hardDeletePlatformSteps: function hardDeletePlatformSteps() {
      return this.hardDeleteActionableSteps.filter(function (p) {
        return (HD_STEP_GROUPS[p.step] || 'platform') === 'platform';
      });
    },
    // Ejecuciones vivas según el preview (Step Functions y Glue).
    hardDeleteRunningCount: function hardDeleteRunningCount() {
      return this.hardDeleteActionableSteps.filter(function (p) {
        return HD_STEP_GROUPS[p.step] === 'runs';
      }).length;
    },
    // force=true para el backend. Se pide confirmarlo cuando hay algo corriendo, cuando la
    // fila está EN_EJECUCION (12) o cuando el backend respondió FORCE_REQUIRED.
    hardDeleteNeedsForce: function hardDeleteNeedsForce() {
      var running = !!this.hardDeleteTarget && Number(this.hardDeleteTarget.estado) === 12;
      return running || this.hardDeleteRunningCount > 0 || this.hardDeleteForceRequired;
    },
    // 1 = nada que borrar · 2 = hay datos o ejecuciones · 3 = además alguien lo usa (o no se
    // pudo comprobar). Sin preview se asume 2: es más seguro pedir el nombre de más.
    hardDeleteLevel: function hardDeleteLevel() {
      if (this.hardDeleteConsumers.count > 0 || this.hardDeleteConsumers.error) return 3;
      if (this.hardDeletePreviewLoading || this.hardDeletePreviewError) return 2;
      if (this.hardDeleteDataSteps.length || this.hardDeleteRunningCount) return 2;
      return 1;
    },
    hardDeleteDescription: function hardDeleteDescription() {
      var key = {
        1: 'desc_nothing',
        2: 'desc_data',
        3: 'desc_consumers'
      }[this.hardDeleteLevel];
      return this.$t("create_attribute.hard_delete.".concat(key));
    },
    // Hay un intento previo con pasos (207, error o fila abierta en ELIMINANDO): el botón
    // reintenta desde el primer paso roto y la confirmación ya se dio.
    hardDeleteRetrying: function hardDeleteRetrying() {
      return !this.hardDeleteSending && this.hardDeleteSteps.length > 0;
    },
    hardDeleteReasonLength: function hardDeleteReasonLength() {
      return (this.hardDeleteReason || '').length;
    },
    hardDeleteReasonValid: function hardDeleteReasonValid() {
      var reason = (this.hardDeleteReason || '').trim();
      return reason.length >= 10 && reason.length <= 500;
    },
    // En un reintento solo se vuelve a pedir el motivo si falta (p. ej. al abrir una fila
    // que quedó en ELIMINANDO): el backend lo exige en cada intento.
    hardDeleteShowConfirm: function hardDeleteShowConfirm() {
      if (this.hardDeleteSending) return false;
      return !this.hardDeleteRetrying || !this.hardDeleteReasonValid;
    },
    hardDeleteReasonError: function hardDeleteReasonError() {
      if (!this.hardDeleteTouched.reason || this.hardDeleteReasonValid) return '';
      return this.$t('create_attribute.hard_delete.reason_min');
    },
    // Solo marca error cuando ya se escribió algo: no se regaña por un campo vacío.
    hardDeleteNameMismatch: function hardDeleteNameMismatch() {
      var expected = this.hardDeleteTargetName;
      var typed = (this.hardDeleteConfirmName || '').trim();
      if (!expected || !typed || typed === expected) return false;
      return this.hardDeleteTouched.name || typed.length >= expected.length;
    },
    hardDeleteShowAlternative: function hardDeleteShowAlternative() {
      var target = this.hardDeleteTarget;
      if (!target || this.hardDeleteSending || this.hardDeleteRetrying || this.hardDeletePreviewLoading) return false;
      // Ya desactivada (21) o con un borrado a medias (23): desactivar no aplica.
      var estado = Number(target.estado);
      return this.hardDeleteLevel >= 2 && estado !== 21 && estado !== 23;
    },
    hardDeleteCategoryAlias: function hardDeleteCategoryAlias() {
      var step = (this.hardDeletePreview || []).find(function (p) {
        return p && p.step === 'typesense_disable_category';
      });
      return step && step.details && step.details.category_alias || '';
    },
    // Filas de "Qué se pierde", de lo más grave a lo que se conserva.
    hardDeleteImpactRows: function hardDeleteImpactRows() {
      var _this3 = this;
      var t = function t(k, p) {
        return _this3.$t("create_attribute.hard_delete.".concat(k), p);
      };
      var tc = function tc(k, n, p) {
        return _this3.$tc("create_attribute.hard_delete.".concat(k), n, p);
      };
      var rows = [];
      var consumers = this.hardDeleteConsumers;
      if (consumers.error) {
        rows.push({
          key: 'consumers',
          tone: 'warn',
          icon: 'mdi-alert-outline',
          tag: t('tag_unconfirmed'),
          title: t('consumers_unknown_title'),
          text: t('consumers_unknown_text')
        });
      } else if (consumers.count > 0) {
        var items = consumers.items.map(function (c) {
          return {
            key: "uc-".concat(c.usecase_id),
            label: c.business_name,
            ref: t('consumer_ref', {
              id: c.usecase_id,
              company: c.company_code
            }),
            mono: false,
            metrics: _this3.consumerStatusText(c)
          };
        });
        var extra = consumers.count - consumers.items.length;
        if (extra > 0) items.push({
          key: 'uc-more',
          label: t('consumers_more', {
            n: extra
          })
        });
        rows.push({
          key: 'consumers',
          tone: 'danger',
          icon: 'mdi-close-octagon-outline',
          tag: t('tag_breaks'),
          title: tc('consumers_title', consumers.count, {
            n: consumers.count
          }),
          text: t('consumers_text'),
          items: items,
          toggleLabel: t('consumers_toggle')
        });
      }
      if (this.hardDeleteNeedsForce) {
        rows.push({
          key: 'runs',
          tone: 'warn',
          icon: 'mdi-alert-outline',
          tag: t('tag_stops'),
          title: t('runs_title'),
          text: t('runs_text')
        });
      }
      var data = this.hardDeleteDataSteps;
      if (data.length) {
        var objects = 0;
        var bytes = 0;
        data.forEach(function (p) {
          var d = p.details || {};
          if (typeof d.objects === 'number') objects += d.objects;
          if (typeof d.versions === 'number') objects += d.versions;
          if (typeof d.bytes === 'number') bytes += d.bytes;
        });
        var summary = [objects ? t('preview_objects', {
          n: objects
        }) : '', this.formatBytes(bytes)].filter(Boolean).join(' · ');
        rows.push({
          key: 'data',
          tone: 'danger',
          icon: 'mdi-close-octagon-outline',
          tag: t('tag_lost'),
          title: tc('data_title', data.length, {
            n: data.length
          }),
          text: summary,
          items: data.map(function (p) {
            return _this3.buildPreviewItem(p, 'data');
          }),
          toggleLabel: t('data_toggle')
        });
      }
      var siblings = this.hardDeleteCategorySiblings;
      if (siblings.length) {
        rows.push({
          key: 'siblings',
          tone: 'warn',
          icon: 'mdi-eye-off-outline',
          tag: t('tag_hidden_too'),
          title: tc('siblings_title', siblings.length, {
            n: siblings.length
          }),
          text: t('siblings_text', {
            alias: this.hardDeleteCategoryAlias
          }),
          items: siblings.map(function (name) {
            return {
              key: "sib-".concat(name),
              label: name,
              mono: true
            };
          }),
          toggleLabel: t('siblings_toggle')
        });
      }
      var platform = this.hardDeletePlatformSteps;
      if (platform.length) {
        rows.push({
          key: 'platform',
          tone: 'info',
          icon: 'mdi-eye-off-outline',
          tag: t('tag_platform'),
          title: t('platform_title'),
          text: t('platform_text'),
          items: platform.map(function (p) {
            return _this3.buildPreviewItem(p, 'platform');
          }),
          toggleLabel: t('data_toggle')
        });
      }
      var config = this.hardDeleteWarningsDetail.filter(function (w) {
        return w && HD_ENV_WARNINGS.includes(w.code);
      });
      if (config.length) {
        rows.push({
          key: 'config',
          tone: 'warn',
          icon: 'mdi-cog-outline',
          tag: t('tag_config'),
          title: t('config_title'),
          text: t('config_text'),
          items: config.map(function (w) {
            return {
              key: "cfg-".concat(w.code),
              label: w.message
            };
          }),
          toggleLabel: t('config_toggle')
        });
      }
      if (!data.length && !this.hardDeleteNeedsForce && !consumers.count && !consumers.error) {
        rows.push({
          key: 'none',
          tone: 'ok',
          icon: 'mdi-check-circle-outline',
          tag: t('tag_none'),
          title: t('none_title'),
          text: t('none_text')
        });
      }
      var untouched = (this.hardDeletePreview || []).filter(function (p) {
        return p && p.step && !p.would_act;
      });
      if (untouched.length) {
        rows.push({
          key: 'untouched',
          tone: 'muted',
          icon: 'mdi-minus-circle-outline',
          tag: t('tag_untouched'),
          title: tc('untouched_title', untouched.length, {
            n: untouched.length
          }),
          items: untouched.map(function (p) {
            return _this3.buildPreviewItem(p, 'untouched');
          }),
          toggleLabel: t('untouched_toggle')
        });
      }
      rows.push({
        key: 'kept',
        tone: 'ok',
        icon: 'mdi-check-circle-outline',
        tag: t('tag_kept'),
        title: t('kept_title'),
        text: t('kept_text')
      });
      return rows;
    },
    // Filas de progreso (mientras borra, desde deletion-status.in_progress) o del checklist
    // del último intento. Los pasos sin nada que borrar se cuentan aparte para no ahogar
    // la lista: lo que importa es lo que se borró, lo que corre y lo que falló.
    hardDeleteStepView: function hardDeleteStepView() {
      var _this4 = this;
      var progress = this.hardDeleteProgress;
      if (this.hardDeleteSending || progress) {
        if (!progress) return {
          rows: [],
          hidden: 0
        };
        var done = {};
        (progress.steps || []).forEach(function (s) {
          done[s.step] = s;
        });
        var relevant = new Set(this.hardDeleteActionableSteps.map(function (p) {
          return p.step;
        }));
        var _rows = [];
        var _hidden = 0;
        (progress.planned_steps || []).forEach(function (step) {
          var result = done[step];
          var state = 'wait';
          if (result) state = {
            ok: 'done',
            error: 'fail'
          }[result.status] || 'none';else if (step === progress.current_step) state = 'run';
          var show = state === 'done' || state === 'fail' || state === 'run' || relevant.has(step);
          if (!show || state === 'none') {
            _hidden += 1;
            return;
          }
          _rows.push(_this4.buildStepRow(step, state, result ? result.detail : ''));
        });
        return {
          rows: _rows,
          hidden: _hidden
        };
      }
      var rows = [];
      var hidden = 0;
      (this.hardDeleteSteps || []).forEach(function (s) {
        var state = {
          ok: 'done',
          error: 'fail',
          pending: 'wait',
          skipped_by_user: 'skipped'
        }[s.status];
        if (!state) {
          hidden += 1;
          return;
        }
        rows.push(_this4.buildStepRow(s.step, state, s.detail));
      });
      return {
        rows: rows,
        hidden: hidden
      };
    },
    hardDeleteStepRows: function hardDeleteStepRows() {
      return this.hardDeleteStepView.rows;
    },
    hardDeleteHiddenStepCount: function hardDeleteHiddenStepCount() {
      return this.hardDeleteStepRows.length ? this.hardDeleteStepView.hidden : 0;
    },
    // Fuente única de "por qué no se puede confirmar": la usan el botón y el texto del pie,
    // para que nunca digan cosas distintas.
    hardDeleteMissing: function hardDeleteMissing() {
      var _this5 = this;
      var t = function t(k) {
        return _this5.$t("create_attribute.hard_delete.".concat(k));
      };
      var missing = [];
      if (this.hardDeleteOutcome && this.hardDeleteOutcome.kind === 'in_progress') {
        missing.push(t('missing_in_progress'));
      }
      if (!this.hardDeleteReasonValid) missing.push(t('missing_reason'));
      if (this.hardDeleteRetrying) return missing;
      if (this.hardDeletePreviewLoading) {
        missing.push(t('missing_preview_loading'));
      } else if (this.hardDeletePreviewError && !(this.hardDeletePreviewFails >= 2 && this.hardDeletePreviewAck)) {
        missing.push(t(this.hardDeletePreviewFails >= 2 ? 'missing_preview_ack' : 'missing_preview_retry'));
      }
      // Sin `nombre_tabla` (pipeline que nunca llegó a crearla) no se exige: quedaría
      // imposible de borrar.
      if (this.hardDeleteLevel >= 2 && this.hardDeleteTargetName && (this.hardDeleteConfirmName || '').trim() !== this.hardDeleteTargetName) {
        missing.push(t('missing_name'));
      }
      if (this.hardDeleteNeedsForce && !this.hardDeleteForce) missing.push(t('missing_force'));
      if (this.hardDeleteLevel === 3 && !this.hardDeleteAckConsumers) missing.push(t('missing_ack'));
      return missing;
    },
    hardDeleteFooterText: function hardDeleteFooterText() {
      if (this.hardDeleteSending) return this.$t('create_attribute.hard_delete.sending_hint');
      var missing = this.hardDeleteMissing;
      if (!missing.length) return '';
      var and = this.$t('create_attribute.hard_delete.missing_and');
      var list = missing.length === 1 ? missing[0] : "".concat(missing.slice(0, -1).join(', '), " ").concat(and, " ").concat(missing[missing.length - 1]);
      return "".concat(this.$t('create_attribute.hard_delete.missing_prefix'), " ").concat(list, ".");
    },
    canConfirmHardDelete: function canConfirmHardDelete() {
      return !this.hardDeleteSending && this.hardDeleteMissing.length === 0;
    },
    deactivateDialogText: function deactivateDialogText() {
      var item = this.itemToDeactivate;
      var name = item && item.nombre_tabla || this.$t('create_attribute.dialogs.deactivate_this');
      return this.$t('create_attribute.dialogs.deactivate_text', {
        name: name
      });
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.$t('create_attribute.title'),
        disabled: true
      }];
    },
    companies: function companies() {
      return ORGS.map(function (org) {
        return {
          text: org.empresa,
          value: org.code
        };
      });
    },
    statusOptions: function statusOptions() {
      var _this6 = this;
      var allOption = {
        text: this.$t('create_attribute.filters.all_statuses'),
        value: null
      };
      if (this.statusCatalog && this.statusCatalog.length) {
        return [allOption].concat(_toConsumableArray(this.statusCatalog.map(function (s) {
          return {
            text: _this6.statusLabel(s.id, s.name),
            value: s.id
          };
        })));
      }
      return [allOption, {
        text: this.$t('create_attribute.status.en_ejecucion'),
        value: 12
      }, {
        text: this.$t('create_attribute.status.ejecutado'),
        value: 14
      }, {
        text: this.$t('create_attribute.status.error'),
        value: 2
      }, {
        text: this.$t('create_attribute.status.solicitado'),
        value: 1
      }, {
        text: this.$t('create_attribute.status.inactive'),
        value: 21
      }];
    },
    loadMonthYears: function loadMonthYears() {
      var currentYear = new Date().getFullYear();
      var years = [];
      for (var i = 0; i < 5; i++) {
        var year = currentYear - i;
        years.push({
          name: year.toString(),
          value: year.toString()
        });
      }
      return years;
    },
    selectedPeriodsSummary: function selectedPeriodsSummary() {
      var _this7 = this;
      if (!this.selectedPeriods || !this.selectedPeriods.length) return '';
      return this.selectedPeriods.slice().sort().map(function (period) {
        return _this7.formatPeriodLabel(period);
      }).join(', ');
    },
    canAddLoadMonthPeriod: function canAddLoadMonthPeriod() {
      var n = (this.selectedPeriods || []).length;
      return !!this.selectedLoadMonth && !!this.selectedLoadYear && n < this.maxLoadMonthPeriods;
    },
    canConfirmLoadMonths: function canConfirmLoadMonths() {
      var n = (this.selectedPeriods || []).length;
      return n >= 1 && n <= this.maxLoadMonthPeriods;
    },
    getClassTable: function getClassTable() {
      return this.filter_enabled ? 'col-md-9 col-sm-12' : 'col-sm-12';
    },
    isSharedWithMe: function isSharedWithMe() {
      var _this8 = this;
      return function (item) {
        var me = window.userInfo && window.userInfo.email;
        return !!me && item.owner_name !== me && !_this8.isAdmin;
      };
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.stopHardDeleteProgressPolling();
  },
  created: function created() {
    this.loadStatusCatalog();
    this.init();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    fetchPage: function fetchPage() {
      var _this9 = this;
      this.setShowLoading(true);
      var query = {
        type_export_id: 5,
        page: this.pagination.current,
        page_size: this.pagination.limit
      };
      // Admin: role=1 + env=all → el backend devuelve TODAS las automatizaciones del tipo,
      // sin filtrar por usuario (incluye las de otros owners/empresas).
      if (this.isAdmin) {
        query.role = 1;
        query.sbidv = 1;
        query.env = 'all';
      } else {
        query.user = window.userInfo.email;
      }
      if (this.filters.use_case) query.use_case = this.filters.use_case;
      if (this.filters.estado !== '' && this.filters.estado !== null && this.filters.estado !== undefined) {
        query.estado = this.filters.estado;
      }
      if (this.filters.fecha) query.fecha_creacion = this.filters.fecha;
      if (this.filters.nombre_tabla) query.nombre_tabla = this.filters.nombre_tabla;
      UseCasesService.getProductizeHistory({
        params: query
      }).then(function (response) {
        var records = response.data && response.data.records || [];
        // El backend ya excluye los dados de baja por defecto, por lo que
        // records y total son consistentes para la paginación.
        _this9.items = records;
        _this9.pagination.total = response.data && response.data.total || 0;
        // Si la página actual quedó fuera de rango (p.ej. al desactivar el último
        // registro de la última página), retroceder; el watcher de pagination.current
        // dispara un nuevo fetchPage().
        var totalPages = Math.ceil(_this9.pagination.total / _this9.pagination.limit) || 1;
        if (_this9.pagination.current > totalPages) {
          _this9.pagination.current = totalPages;
        }
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this9.translate('error_messages.error_general'), _this9.translate('titles.error'));
      }).finally(function () {
        _this9.setShowLoading(false);
      });
    },
    init: function init() {
      this.pagination.current = 1;
      this.fetchPage();
    },
    refreshClick: function refreshClick() {
      this.fetchPage();
    },
    onLimpiar: function onLimpiar() {
      this.filters = {
        empresa: '',
        estado: '',
        use_case: '',
        fecha: '',
        nombre_tabla: ''
      };
      this.pagination.current = 1;
      this.fetchPage();
    },
    onBuscar: function onBuscar() {
      this.pagination.current = 1;
      this.fetchPage();
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    openCreateDialog: function openCreateDialog() {
      this.fetchExistingTableNames();
      this.openDialog(this.DIALOG_CREATE);
    },
    onDownloadLineamientos: function onDownloadLineamientos() {
      FilesService.readFileProject('/manuals/lineamientos-automatizacion-crear-atributo-v1.pdf').then(function (response) {
        if (response.success) {
          var filename = response.data.name.split('/').pop();
          var base64String = response.data.base64.split('base64,')[1];
          var byteCharacters = atob(base64String);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
            type: 'application/pdf'
          });
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          tasks.toast.error('No se pudo descargar el archivo, intentelo mas tarde.');
        }
      });
    },
    fetchExistingTableNames: function () {
      var _fetchExistingTableNames = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var PAGE_SIZE, MAX_PAGES, baseQuery, names, page, total, response, records, _iterator, _step, r, n, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              PAGE_SIZE = 200;
              MAX_PAGES = 50;
              baseQuery = {
                type_export_id: 5,
                page_size: PAGE_SIZE,
                role: 1,
                sbidv: 1,
                env: 'all'
              };
              names = [];
              _context.p = 1;
              page = 1;
              total = Infinity;
            case 2:
              if (!((page - 1) * PAGE_SIZE < total && page <= MAX_PAGES)) {
                _context.n = 13;
                break;
              }
              _context.n = 3;
              return UseCasesService.getProductizeHistory({
                params: _objectSpread(_objectSpread({}, baseQuery), {}, {
                  page: page
                })
              });
            case 3:
              response = _context.v;
              records = response.data && response.data.records || [];
              total = response.data && response.data.total || 0;
              if (!(records.length === 0)) {
                _context.n = 4;
                break;
              }
              return _context.a(3, 13);
            case 4:
              _iterator = _createForOfIteratorHelper(records);
              _context.p = 5;
              _iterator.s();
            case 6:
              if ((_step = _iterator.n()).done) {
                _context.n = 9;
                break;
              }
              r = _step.value;
              if (!(Number(r.estado) === 20)) {
                _context.n = 7;
                break;
              }
              return _context.a(3, 8);
            case 7:
              n = (r.nombre_tabla || '').toLowerCase();
              if (n) names.push(n);
            case 8:
              _context.n = 6;
              break;
            case 9:
              _context.n = 11;
              break;
            case 10:
              _context.p = 10;
              _t = _context.v;
              _iterator.e(_t);
            case 11:
              _context.p = 11;
              _iterator.f();
              return _context.f(11);
            case 12:
              page++;
              _context.n = 2;
              break;
            case 13:
              this.existingTableNames = names;
              _context.n = 15;
              break;
            case 14:
              _context.p = 14;
              _t2 = _context.v;
              this.existingTableNames = [];
            case 15:
              return _context.a(2);
          }
        }, _callee, this, [[5, 10, 11, 12], [1, 14]]);
      }));
      function fetchExistingTableNames() {
        return _fetchExistingTableNames.apply(this, arguments);
      }
      return fetchExistingTableNames;
    }(),
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
    },
    formatDateTimeLima: function formatDateTimeLima(dateString) {
      if (!dateString) return '';
      var value = String(dateString);
      var localMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?)?$/);
      if (localMatch) {
        var _localMatch = _slicedToArray(localMatch, 6),
          year = _localMatch[1],
          month = _localMatch[2],
          day = _localMatch[3],
          _localMatch$ = _localMatch[4],
          hour = _localMatch$ === void 0 ? '00' : _localMatch$,
          _localMatch$2 = _localMatch[5],
          minute = _localMatch$2 === void 0 ? '00' : _localMatch$2;
        return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hour, ":").concat(minute);
      }
      var parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) return value;
      return new Intl.DateTimeFormat('es-PE', {
        timeZone: 'America/Lima',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(parsedDate).replace(',', '');
    },
    loadStatusCatalog: function loadStatusCatalog() {
      var _this0 = this;
      UseCasesService.getPipelineStatusesCatalog().then(function (response) {
        var list = response && response.data && response.data.statuses || [];
        _this0.statusCatalog = list;
      }).catch(function (err) {
        // Fallback silencioso al mapa hardcodeado — no bloquea la UI
        console.warn('pipeline-statuses catalog fallback:', err);
        _this0.statusCatalog = [];
      });
    },
    getStatus: function getStatus(statusId) {
      var numericStatusId = Number(statusId);
      if (this.statusCatalog && this.statusCatalog.length) {
        var hit = this.statusCatalog.find(function (s) {
          return Number(s.id) === numericStatusId;
        });
        if (hit) {
          return {
            text: this.statusLabel(numericStatusId, hit.name),
            color: hit.color,
            textColor: hit.text_color
          };
        }
      }
      // Fallback: mapa canonico del flujo (EN_EJECUCION / EJECUTADO / ERROR / INACTIVO)
      var statusMap = {
        1: {
          text: this.$t('create_attribute.status.solicitado'),
          color: 'warning',
          textColor: 'white'
        },
        2: {
          text: this.$t('create_attribute.status.error'),
          color: 'error',
          textColor: 'white'
        },
        12: {
          text: this.$t('create_attribute.status.en_ejecucion'),
          color: 'info',
          textColor: 'white'
        },
        14: {
          text: this.$t('create_attribute.status.ejecutado'),
          color: 'success',
          textColor: 'white'
        },
        21: {
          text: this.$t('create_attribute.status.inactive'),
          color: 'grey',
          textColor: 'white'
        }
      };
      return statusMap[numericStatusId] || {
        text: statusId,
        color: 'grey',
        textColor: 'white'
      };
    },
    isInactiveStatus: function isInactiveStatus(statusId) {
      return Number(statusId) === 21 || String(statusId || '').toUpperCase() === 'INACTIVO';
    },
    // SOLICITADO (1): solicitud pendiente de aprobación en "Gestionar solicitudes";
    // el script SQL aún no existe en la ruta canónica de S3, cargar meses fallaría con 404.
    isPendingReviewStatus: function isPendingReviewStatus(statusId) {
      return Number(statusId) === 1 || String(statusId || '').toUpperCase() === 'SOLICITADO';
    },
    isErrorStatus: function isErrorStatus(statusId) {
      return Number(statusId) === 2 || String(statusId || '').toUpperCase() === 'ERROR';
    },
    statusLabel: function statusLabel(statusId) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return this.isInactiveStatus(statusId) ? this.$t('create_attribute.status.inactive') : fallback || statusId;
    },
    openDetailDialog: function openDetailDialog(item) {
      this.selectedItem = item;
      this.openDialog(this.DIALOG_DETAIL);
    },
    openActivityTimeline: function openActivityTimeline(item) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.selectedItem = item;
      if (this.$refs.activityTimelineDialog && this.$refs.activityTimelineDialog.open) {
        this.$refs.activityTimelineDialog.open(item, _objectSpread(_objectSpread({}, opts), {}, {
          isIntercorpAdmin: this.isIntercorpAdmin
        }));
      }
    },
    openLoadMonthsDialog: function openLoadMonthsDialog(item) {
      if (this.isPendingReviewStatus(item.estado)) {
        tasks.toast.info(this.$t('create_attribute.rules.load_months_pending_review'));
        return;
      }
      this.selectedItem = item;
      this.selectedLoadMonth = null;
      this.selectedLoadYear = null;
      this.selectedPeriods = [];
      this.openDialog(this.DIALOG_LOAD_MONTHS);
    },
    formatPeriodLabel: function formatPeriodLabel(period) {
      var match = /^(\d{4})-(\d{2})-01$/.exec(period);
      if (!match) return period;
      var monthMatch = this.months.find(function (m) {
        return m.value === match[2];
      });
      var monthName = monthMatch ? monthMatch.name : match[2];
      return "".concat(monthName, " ").concat(match[1]);
    },
    addLoadMonthPeriod: function addLoadMonthPeriod() {
      if (!this.selectedLoadMonth || !this.selectedLoadYear) return;
      if (this.selectedPeriods.length >= this.maxLoadMonthPeriods) {
        tasks.toast.info(this.$t('create_attribute.rules.max_periods', {
          max: this.maxLoadMonthPeriods
        }));
        return;
      }
      var period = "".concat(this.selectedLoadYear, "-").concat(this.selectedLoadMonth, "-01");
      if (this.selectedPeriods.includes(period)) {
        tasks.toast.info(this.$t('create_attribute.rules.period_duplicate'));
        return;
      }
      this.selectedPeriods.push(period);
    },
    removeLoadMonthPeriod: function removeLoadMonthPeriod(index) {
      this.selectedPeriods.splice(index, 1);
    },
    confirmLoadMonths: function confirmLoadMonths() {
      var _this1 = this;
      if (this.loadMonthsSending) return;
      if (!this.canConfirmLoadMonths) {
        tasks.toast.error(this.$t('create_attribute.errors.select_period'));
        return;
      }
      var periods = this.selectedPeriods.slice().sort();
      var data = {
        periods: periods,
        load_history: true
      };
      var itemToFocus = _objectSpread(_objectSpread({}, this.selectedItem), {}, {
        estado: 12,
        status_id: 12
      });
      this.loadMonthsSending = true;
      this.setShowLoading(true);
      UseCasesService.loadMonthsAttributeAutomation(this.selectedItem.automate_id, data).then(function (response) {
        var responseData = response && response.data || response || {};
        var automateId = responseData.automate_id || responseData.id || itemToFocus.automate_id;
        _this1.loadMonthsAutomationItem = _objectSpread(_objectSpread({}, itemToFocus), {}, {
          automate_id: automateId
        });
        _this1.onCloseDialog(_this1.DIALOG_LOAD_MONTHS);
        _this1.fetchPage();
        _this1.$refs.dialogLoadMonthsSuccess.onOpen();
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this1.translate('error_messages.error_general'), _this1.translate('titles.error'));
      }).finally(function () {
        _this1.loadMonthsSending = false;
        _this1.setShowLoading(false);
      });
    },
    hasActiveBatch: function hasActiveBatch(item) {
      var cb = item && item.current_batch;
      if (!cb || !Array.isArray(cb.periods) || cb.periods.length === 0) return false;
      var total = cb.periods.length;
      var done = Number.isFinite(item.completed_periods) ? item.completed_periods : 0;
      return done < total;
    },
    batchProgressLabel: function batchProgressLabel(item) {
      var cb = item && item.current_batch || {};
      var total = (cb.periods || []).length;
      var done = Number.isFinite(item.completed_periods) ? item.completed_periods : 0;
      return this.$t('create_attribute.load_months.badge_progress', {
        done: done,
        total: total
      });
    },
    deactivateAutomation: function deactivateAutomation(item) {
      this.itemToDeactivate = item;
      this.$refs.dialogDeactivate.onOpen();
    },
    onConfirmDeactivate: function onConfirmDeactivate(confirmed) {
      var _this10 = this;
      if (!confirmed) {
        this.$refs.dialogDeactivate.onClose();
        return;
      }
      this.setShowLoading(true);
      UseCasesService.deactivateAttributeAutomation(this.itemToDeactivate.automate_id).then(function () {
        tasks.toast.success(_this10.$t('create_attribute.success.deactivated'));
        _this10.$refs.dialogDeactivate.onClose();
        // El backend ya no devuelve los dados de baja; recargar refleja el cambio
        // y actualiza el total de la paginación.
        _this10.fetchPage();
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this10.translate('error_messages.error_general'), _this10.translate('titles.error'));
      }).finally(function () {
        _this10.setShowLoading(false);
        _this10.itemToDeactivate = null;
      });
    },
    openEditScriptDialog: function openEditScriptDialog(item) {
      this.$refs.editScriptDialog.open(item);
    },
    onScriptUpdated: function onScriptUpdated() {
      this.fetchPage();
    },
    goToMetadata: function goToMetadata(item) {
      if (!item.nombre_tabla) {
        tasks.toast.error(this.$t('create_attribute.errors.table_not_ready'));
        return;
      }
      var gcpTable = "ba_ibk_attr_".concat(item.nombre_tabla);
      this.$router.push({
        name: 'ContObjectSearch',
        params: {
          q: gcpTable,
          domain: 'All'
        },
        query: {
          all: false,
          table: false,
          term: false,
          data: false,
          book: false,
          dataset: false,
          report: false,
          report_gds: false,
          titulo: false,
          description: false
        }
      });
    },
    onFormStepChanged: function onFormStepChanged(step) {
      this.createFormStep = step;
    },
    onFormValidityChanged: function onFormValidityChanged(val) {
      this.createFormValid = val;
    },
    // Destinos que el backend acepta desde `estado`. Lista vacía = el estado actual no
    // admite override manual (SOLICITADO, DESACTIVO, ELIMINANDO, ELIMINADO).
    allowedStatusTargets: function allowedStatusTargets(estado) {
      return MANUAL_STATUS_TRANSITIONS[Number(estado)] || [];
    },
    openChangeStatusDialog: function openChangeStatusDialog(item) {
      if (!this.isIntercorpAdmin) return;
      var targets = this.allowedStatusTargets(item.estado);
      if (!targets.length) {
        tasks.toast.warning(this.$t('create_attribute.change_status.not_allowed'));
        return;
      }
      this.changeStatusTarget = item;
      this.changeStatusNewStatus = null;
      this.changeStatusReason = '';
      this.openDialog(this.DIALOG_CHANGE_STATUS);
    },
    confirmChangeStatus: function confirmChangeStatus() {
      var _this11 = this;
      if (!this.canConfirmChangeStatus || this.changeStatusSending) return;
      this.changeStatusSending = true;
      UseCasesService.changeAttributeAutomationStatus(this.changeStatusTarget.automate_id, {
        status_id: Number(this.changeStatusNewStatus),
        reason: this.changeStatusReason.trim()
      }).then(function (data) {
        tasks.toast.success(data && data.message || _this11.$t('create_attribute.change_status.success'));
        _this11.onCloseDialog(_this11.DIALOG_CHANGE_STATUS);
        _this11.changeStatusTarget = null;
        // Recargar: el estado cambió y los filtros por estado pueden sacar la fila de la página.
        _this11.fetchPage();
      }).catch(function (err) {
        console.error(err);
        var res = err && err.response;
        var message = res && res.data && res.data.message;
        // 409 = el backend rechazó la transición (la fila cambió de estado entre que se
        // abrió el diálogo y se confirmó). 403 = Firestore no confirmó el rol admin.
        if (res && (res.status === 409 || res.status === 403)) {
          tasks.toast.error(message || _this11.$t('create_attribute.change_status.rejected'), _this11.translate('titles.error'));
        } else {
          tasks.toast.error(message || _this11.translate('error_messages.error_general'), _this11.translate('titles.error'));
        }
      }).finally(function () {
        _this11.changeStatusSending = false;
      });
    },
    // ── Borrado definitivo v2 ──────────────────────────────────────────────
    resetHardDeleteState: function resetHardDeleteState(item) {
      this.hardDeleteTarget = item;
      this.hardDeleteOpenerId = item ? item.automate_id : null;
      this.hardDeleteReason = '';
      this.hardDeleteConfirmName = '';
      this.hardDeleteForce = false;
      this.hardDeleteForceRequired = false;
      this.hardDeleteAckConsumers = false;
      this.hardDeleteTouched = {
        reason: false,
        name: false
      };
      this.hardDeletePreview = [];
      this.hardDeleteWarningsDetail = [];
      this.hardDeleteConsumers = {
        count: 0,
        items: [],
        error: null
      };
      this.hardDeleteCategorySiblings = [];
      this.hardDeletePreviewError = '';
      this.hardDeletePreviewFails = 0;
      this.hardDeletePreviewAck = false;
      this.hardDeleteSteps = [];
      this.hardDeleteResumeFrom = null;
      this.hardDeleteSkipSteps = [];
      this.hardDeleteProgress = null;
      this.hardDeleteOutcome = null;
      this.hardDeleteLiveMessage = '';
      this.hardDeleteOpenDetails = [];
    },
    openHardDeleteDialog: function openHardDeleteDialog(item) {
      if (!this.canHardDelete) return;
      this.resetHardDeleteState(item);
      this.openDialog(this.DIALOG_HARD_DELETE);
      this.loadHardDeletePreview(item);
      // Si quedó un intento parcial previo (ELIMINANDO=23), traer su checklist para
      // poder retomarlo en vez de arrancar de cero.
      if (Number(item.estado) === 23) {
        this.loadDeletionStatus(item);
      }
    },
    closeHardDeleteDialog: function closeHardDeleteDialog() {
      // Mientras borra no se cierra: la petición seguiría y el resultado se perdería.
      if (this.hardDeleteSending) return;
      this.onCloseDialog(this.DIALOG_HARD_DELETE);
    },
    // Lo emite DialogsComponent al cerrar por la X, por Escape o por closeHardDeleteDialog.
    // El foco vuelve al ⋮ de la fila; si la fila ya no está, al título de la página.
    onHardDeleteClosed: function onHardDeleteClosed() {
      var _this12 = this;
      this.stopHardDeleteProgressPolling();
      var openerId = this.hardDeleteOpenerId;
      this.$nextTick(function () {
        window.setTimeout(function () {
          var button = openerId != null && _this12.$el ? _this12.$el.querySelector("[data-row-actions=\"".concat(openerId, "\"]")) : null;
          if (button) button.focus();else if (_this12.$refs.pageTitle) _this12.$refs.pageTitle.focus();
        }, 0);
      });
    },
    deactivateInsteadOfDelete: function deactivateInsteadOfDelete() {
      var _this13 = this;
      var item = this.hardDeleteTarget;
      this.closeHardDeleteDialog();
      if (item) this.$nextTick(function () {
        return _this13.deactivateAutomation(item);
      });
    },
    isHardDeleteDetailOpen: function isHardDeleteDetailOpen(key) {
      return this.hardDeleteOpenDetails.includes(key);
    },
    toggleHardDeleteDetail: function toggleHardDeleteDetail(key) {
      this.hardDeleteOpenDetails = this.isHardDeleteDetailOpen(key) ? this.hardDeleteOpenDetails.filter(function (k) {
        return k !== key;
      }) : [].concat(_toConsumableArray(this.hardDeleteOpenDetails), [key]);
    },
    consumerStatusText: function consumerStatusText(consumer) {
      var raw = consumer && consumer.access_deadline_date;
      if (!raw) return '';
      var _String$slice$split = String(raw).slice(0, 10).split('-'),
        _String$slice$split2 = _slicedToArray(_String$slice$split, 3),
        year = _String$slice$split2[0],
        month = _String$slice$split2[1],
        day = _String$slice$split2[2];
      var date = "".concat(day, "/").concat(month, "/").concat(year);
      var status = Number(consumer.status_id);
      var key = status === 10 ? 'consumer_expired' : [3, 13].includes(status) ? 'consumer_active' : 'consumer_other';
      return this.$t("create_attribute.hard_delete.".concat(key), {
        date: date
      });
    },
    // Etiqueta legible de un paso. Si falta la traducción se muestra la clave técnica:
    // es preferible un nombre feo a una fila vacía en una acción irreversible.
    stepLabel: function stepLabel(step) {
      var key = "create_attribute.hard_delete.steps.".concat(step);
      var label = this.$t(key);
      return label === key ? step : label;
    },
    buildStepRow: function buildStepRow(step, state, detail) {
      var icons = {
        done: 'mdi-check-circle',
        run: 'mdi-progress-clock',
        wait: 'mdi-clock-outline',
        fail: 'mdi-alert-circle',
        skip: 'mdi-debug-step-over',
        skipped: 'mdi-debug-step-over'
      };
      var labels = {
        done: 'state_done',
        run: 'state_run',
        wait: 'state_wait',
        fail: 'state_fail',
        skip: 'state_skip',
        skipped: 'state_skipped'
      };
      // "Omitir" solo en un reintento y solo en los pasos cuyo resto es auditable: saltar
      // Glue, S3 o la purga en la base deja el atributo ELIMINADO con datos vivos.
      var retryable = this.hardDeleteRetrying && (state === 'fail' || state === 'wait');
      var skippable = HD_SKIPPABLE_STEPS.includes(step);
      var shown = retryable && this.hardDeleteSkipSteps.includes(step) ? 'skip' : state;
      return {
        step: step,
        state: shown,
        icon: icons[shown],
        stateLabel: this.$t("create_attribute.hard_delete.".concat(labels[shown])),
        label: this.stepLabel(step),
        detail: state === 'fail' ? String(detail || '').slice(0, 240) : '',
        canSkip: retryable && skippable,
        skipBlocked: retryable && !skippable && state === 'fail'
      };
    },
    // Bytes legibles. Devuelve '' si el backend no mandó tamaño: preferimos no mostrar
    // métrica a mostrar un "0 B" que parece un dato medido.
    formatBytes: function formatBytes(bytes) {
      var total = Number(bytes);
      if (!total || total < 0) return '';
      var units = ['B', 'KB', 'MB', 'GB', 'TB'];
      var value = total;
      var unit = 0;
      while (value >= 1024 && unit < units.length - 1) {
        value /= 1024;
        unit += 1;
      }
      var rounded = unit === 0 || value >= 100 ? Math.round(value) : value.toFixed(1);
      return "".concat(rounded, " ").concat(units[unit]);
    },
    // Traduce un paso del preview a una fila del detalle técnico: ruta del recurso y
    // métricas. Solo se muestra lo que el backend envió.
    buildPreviewItem: function buildPreviewItem(p, groupKey) {
      var _this14 = this;
      var d = p.details || {};
      var t = function t(k, params) {
        return _this14.$t("create_attribute.hard_delete.".concat(k), params);
      };
      var item = {
        key: p.step,
        label: this.stepLabel(p.step),
        ref: '',
        mono: true,
        metrics: ''
      };

      // El backend manda `prefix` cuando borra un prefijo completo y `key` cuando borra un
      // objeto exacto. Sin ninguna de las dos no se pinta ruta: `s3://{bucket}/` a secas
      // insinúa el bucket entero.
      var objectPath = d.prefix || d.key || '';
      var scheme = p.step.indexOf('gcs') === 0 ? 'gs://' : 's3://';
      // `bq_drop_temps` apunta a varios datasets a la vez: los refs van uno por línea.
      var refList = Array.isArray(d.tables) && d.tables.length && typeof d.tables[0] === 'string' ? d.tables.join('\n') : '';
      if (d.table_ref) item.ref = d.table_ref;else if (refList) item.ref = refList;else if (d.bucket && objectPath) item.ref = "".concat(scheme).concat(d.bucket, "/").concat(objectPath);else if (d.bucket) item.ref = d.bucket;else if (d.database && d.table) item.ref = "".concat(d.database, " / ").concat(d.table);else if (d.database) item.ref = d.database;else if (d.category_alias) item.ref = d.category_alias;else if (d.id_firestore) item.ref = d.id_firestore;else if (d.execution_arn) item.ref = String(d.execution_arn).split(':').pop();
      var metrics = [];
      if (Array.isArray(d.running_run_ids) && d.running_run_ids.length) {
        metrics.push(t('runs_count', {
          n: d.running_run_ids.length
        }));
      } else if (typeof d.objects === 'number') {
        metrics.push(t('preview_objects', {
          n: d.objects
        }));
      } else if (typeof d.versions === 'number') {
        metrics.push(t('versions_count', {
          n: d.versions
        }));
      } else if (Array.isArray(d.tables)) {
        metrics.push(t('tables_count', {
          n: d.tables.length
        }));
      } else if (typeof d.period_rows === 'number') {
        metrics.push(t('rows_period_hist', {
          period: d.period_rows,
          hist: d.hist_rows
        }));
      }
      if (typeof d.bytes === 'number') metrics.push(this.formatBytes(d.bytes));
      // Retención S3: el objeto no desaparece hoy, y eso se dice explícitamente.
      if (p.deferred && p.purge_eta) {
        metrics.push(t('retention_note', {
          days: p.retention_days,
          date: p.purge_eta
        }));
      }
      item.metrics = metrics.filter(Boolean).join(' · ');

      // En "Nada que borrar" el motivo ES la información útil: reemplaza a la ruta.
      if (groupKey === 'untouched') {
        item.ref = p.reason || item.ref;
        item.mono = !p.reason;
        item.metrics = '';
      }
      return item;
    },
    loadHardDeletePreview: function () {
      var _loadHardDeletePreview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var result, data, consumers, respData, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.hardDeletePreviewLoading = true;
              this.hardDeletePreviewError = '';
              _context2.p = 1;
              _context2.n = 2;
              return UseCasesService.getHardDeletePreview(item.automate_id);
            case 2:
              result = _context2.v;
              data = result && result.data || {};
              this.hardDeletePreview = data.preview || [];
              this.hardDeleteWarningsDetail = data.warnings_detail || (data.warnings || []).map(function (message) {
                return {
                  code: '',
                  message: message
                };
              });
              consumers = data.consumers || {};
              this.hardDeleteConsumers = {
                count: Number(consumers.count) || 0,
                items: Array.isArray(consumers.items) ? consumers.items : [],
                error: consumers.error || null
              };
              this.hardDeleteCategorySiblings = Array.isArray(data.category_siblings) ? data.category_siblings : [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t3 = _context2.v;
              // No se silencia: se muestra el motivo, se ofrece reintentar y, si vuelve a fallar,
              // se exige confirmación explícita para borrar sin ver el detalle.
              console.error('No se pudo leer hard-delete-preview', _t3);
              respData = _t3 && _t3.response && _t3.response.data || {};
              this.hardDeletePreviewFails += 1;
              this.hardDeletePreviewError = respData.message || respData.detail || _t3 && _t3.message || 'error';
              this.hardDeleteLiveMessage = this.$t('create_attribute.hard_delete.preview_error_title');
            case 4:
              _context2.p = 4;
              this.hardDeletePreviewLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function loadHardDeletePreview(_x) {
        return _loadHardDeletePreview.apply(this, arguments);
      }
      return loadHardDeletePreview;
    }(),
    retryHardDeletePreview: function retryHardDeletePreview() {
      if (this.hardDeleteTarget) this.loadHardDeletePreview(this.hardDeleteTarget);
    },
    loadDeletionStatus: function () {
      var _loadDeletionStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(item) {
        var result, data, last, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return UseCasesService.getDeletionStatus(item.automate_id);
            case 1:
              result = _context3.v;
              data = result && result.data || {};
              if (data.in_progress) {
                this.hardDeleteProgress = data.in_progress;
              } else {
                this.hardDeleteProgress = null;
                last = data.last_attempt || null;
                if (last && last.final_status === 'partial') this.applyDeletionAttempt(last);
              }
              return _context3.a(2, data);
            case 2:
              _context3.p = 2;
              _t4 = _context3.v;
              // El checklist es informativo: si no se puede leer, el borrado sigue disponible
              // desde cero. Se registra para no ocultar el fallo.
              console.error('No se pudo leer deletion-status', _t4);
              return _context3.a(2, null);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function loadDeletionStatus(_x2) {
        return _loadDeletionStatus.apply(this, arguments);
      }
      return loadDeletionStatus;
    }(),
    // Botón del aviso "otra persona lo está eliminando": muestra el avance de esa
    // eliminación o, si ya terminó, cómo quedó.
    refreshDeletionInProgress: function () {
      var _refreshDeletionInProgress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var target, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              target = this.hardDeleteTarget;
              if (target) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return this.loadDeletionStatus(target);
            case 2:
              data = _context4.v;
              if (!(!data || data.in_progress)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              this.hardDeleteOutcome = null;
              if (Number(data.status_id) === 20) {
                tasks.toast.info(this.$t('create_attribute.hard_delete.outcome_already', {
                  name: this.hardDeleteTargetName
                }));
                this.closeHardDeleteDialog();
                this.fetchPage();
              }
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function refreshDeletionInProgress() {
        return _refreshDeletionInProgress.apply(this, arguments);
      }
      return refreshDeletionInProgress;
    }(),
    applyDeletionAttempt: function applyDeletionAttempt(attempt) {
      var steps = attempt && attempt.steps || [];
      this.hardDeleteSteps = steps;
      // Se retoma desde el primer paso que falló o quedó pendiente; los anteriores ya
      // están hechos y son idempotentes, pero no hace falta repetirlos.
      var firstBroken = steps.find(function (s) {
        return s.status === 'error' || s.status === 'pending';
      });
      this.hardDeleteResumeFrom = firstBroken ? firstBroken.step : null;
      this.hardDeleteSkipSteps = [];
    },
    startHardDeleteProgressPolling: function startHardDeleteProgressPolling(automateId) {
      var _this15 = this;
      this.stopHardDeleteProgressPolling();
      this.hardDeletePollTimer = window.setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var result, inProgress, before, planned, current, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!_this15.hardDeletePollBusy) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _this15.hardDeletePollBusy = true;
              _context5.p = 2;
              _context5.n = 3;
              return UseCasesService.getDeletionStatus(automateId);
            case 3:
              result = _context5.v;
              inProgress = result && result.data && result.data.in_progress;
              if (inProgress && _this15.hardDeleteSending) {
                before = _this15.hardDeleteProgress && _this15.hardDeleteProgress.current_step;
                _this15.hardDeleteProgress = inProgress;
                planned = inProgress.planned_steps || [];
                current = inProgress.current_step;
                if (current && current !== before) {
                  _this15.hardDeleteLiveMessage = _this15.$t('create_attribute.hard_delete.progress_step', {
                    current: planned.indexOf(current) + 1,
                    total: planned.length,
                    label: _this15.stepLabel(current)
                  });
                }
              }
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t5 = _context5.v;
              // El progreso es informativo: el resultado lo da el DELETE. Se registra y se
              // sigue esperando.
              console.error('No se pudo leer el progreso del borrado', _t5);
            case 5:
              _context5.p = 5;
              _this15.hardDeletePollBusy = false;
              return _context5.f(5);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, null, [[2, 4, 5, 6]]);
      })), HD_POLL_MS);
    },
    stopHardDeleteProgressPolling: function stopHardDeleteProgressPolling() {
      if (this.hardDeletePollTimer) {
        window.clearInterval(this.hardDeletePollTimer);
        this.hardDeletePollTimer = null;
      }
      this.hardDeletePollBusy = false;
    },
    // ISO sin zona del backend: Cloud Run corre en UTC.
    formatHardDeleteTime: function formatHardDeleteTime(iso) {
      var plusMinutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!iso) return '';
      var value = /[zZ]|[+-]\d{2}:?\d{2}$/.test(iso) ? iso : "".concat(iso, "Z");
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      date.setMinutes(date.getMinutes() + plusMinutes);
      return date.toLocaleTimeString('es-PE', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    partialHardDeleteOutcome: function partialHardDeleteOutcome(steps) {
      var _this16 = this;
      var t = function t(k, p) {
        return _this16.$t("create_attribute.hard_delete.".concat(k), p);
      };
      var list = steps || [];
      var failed = list.find(function (s) {
        return s.status === 'error';
      }) || {};
      var done = list.filter(function (s) {
        return ['ok', 'skipped', 'skipped_by_user'].includes(s.status);
      }).length;
      var actions = {
        glue_delete_table: 'outcome_partial_glue_action',
        dataplex_metadata_delete: 'outcome_partial_dataplex_action'
      };
      return {
        kind: 'partial',
        tone: 'error',
        title: t('outcome_partial_title'),
        text: t('outcome_partial_text', {
          done: done,
          total: list.length,
          step: this.stepLabel(failed.step || ''),
          detail: String(failed.detail || '').slice(0, 200)
        }),
        action: t(actions[failed.step] || 'outcome_partial_action')
      };
    },
    // Traduce el error del DELETE a lo que ve la persona: qué pasó y qué hacer. Usa el
    // `error_code` estable del backend; el status HTTP queda como respaldo.
    hardDeleteErrorOutcome: function hardDeleteErrorOutcome(err) {
      var _this17 = this;
      var t = function t(k, p) {
        return _this17.$t("create_attribute.hard_delete.".concat(k), p);
      };
      var res = err && err.response;
      var status = res && res.status;
      var body = res && res.data || {};
      var data = body.data || {};
      var code = data.error_code || '';
      if (code === 'DELETION_IN_PROGRESS' || status === 409 && data.deletion_in_progress) {
        var info = data.deletion_in_progress || {};
        return {
          kind: 'in_progress',
          tone: 'warn',
          title: t('outcome_in_progress_title'),
          text: t('outcome_in_progress_text', {
            who: info.deleted_by || '-',
            time: this.formatHardDeleteTime(info.started_at) || '-',
            retry_time: this.formatHardDeleteTime(info.started_at, Number(info.grace_minutes) || 15) || '-'
          })
        };
      }
      if (code === 'FORCE_REQUIRED') {
        return {
          kind: 'force',
          tone: 'warn',
          title: t('outcome_force_title'),
          text: t('outcome_force_text')
        };
      }
      if (code === 'FORBIDDEN_NOT_ADMIN' || status === 403) {
        return {
          kind: 'forbidden',
          tone: 'error',
          title: t('outcome_forbidden_title'),
          text: t('outcome_forbidden_text')
        };
      }
      if (code === 'AUTOMATE_NOT_FOUND' || status === 404) {
        return {
          kind: 'not_found',
          tone: 'error',
          title: t('outcome_not_found_title'),
          text: t('outcome_not_found_text')
        };
      }
      if (code === 'NOT_PIPELINE_V2') {
        return {
          kind: 'not_v2',
          tone: 'error',
          title: t('outcome_not_v2_title'),
          text: t('outcome_not_v2_text')
        };
      }
      if (code === 'INVALID_TRANSITION' || status === 409) {
        return {
          kind: 'transition',
          tone: 'warn',
          title: t('outcome_transition_title'),
          text: t('outcome_transition_text')
        };
      }
      return {
        kind: 'error',
        tone: 'error',
        title: t('outcome_error_title'),
        text: t('outcome_error_text'),
        action: t('outcome_error_action')
      };
    },
    confirmHardDelete: function () {
      var _confirmHardDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var target, name, result, data, key, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!this.hardDeleteSending) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              if (this.canConfirmHardDelete) {
                _context6.n = 2;
                break;
              }
              this.hardDeleteTouched = {
                reason: true,
                name: true
              };
              this.hardDeleteLiveMessage = this.hardDeleteFooterText;
              return _context6.a(2);
            case 2:
              target = this.hardDeleteTarget;
              if (!(!target || !target.automate_id)) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2);
            case 3:
              name = this.hardDeleteTargetName || String(target.automate_id);
              this.hardDeleteSending = true;
              this.hardDeleteOutcome = null;
              this.hardDeleteProgress = null;
              this.hardDeleteLiveMessage = this.$t('create_attribute.hard_delete.sending_hint');
              this.startHardDeleteProgressPolling(target.automate_id);
              _context6.p = 4;
              _context6.n = 5;
              return UseCasesService.hardDeleteAttributeAutomation(target.automate_id, {
                reason: this.hardDeleteReason.trim(),
                force: this.hardDeleteNeedsForce && !!this.hardDeleteForce,
                resume_from: this.hardDeleteResumeFrom,
                skip_steps: this.hardDeleteSkipSteps
              });
            case 5:
              result = _context6.v;
              // Backend devuelve 200 (complete) o 207 (partial). El service ya leyó response.data.
              data = result && result.data || {};
              if (!(data.already_deleted || (data.final_status || 'complete') === 'complete')) {
                _context6.n = 6;
                break;
              }
              this.hardDeleteSending = false;
              this.stopHardDeleteProgressPolling();
              key = data.already_deleted ? 'outcome_already' : 'outcome_success';
              tasks.toast.success(this.$t("create_attribute.hard_delete.".concat(key), {
                name: name
              }));
              this.closeHardDeleteDialog();
              this.fetchPage();
              return _context6.a(2);
            case 6:
              // Parcial: el diálogo NO se cierra — se muestra el checklist para reintentar el
              // paso que falló o, si se puede, omitirlo.
              this.applyDeletionAttempt(data);
              this.hardDeleteOutcome = this.partialHardDeleteOutcome(data.steps);
              this.fetchPage();
              _context6.n = 8;
              break;
            case 7:
              _context6.p = 7;
              _t6 = _context6.v;
              console.error('Hard delete falló', _t6);
              this.hardDeleteOutcome = this.hardDeleteErrorOutcome(_t6);
              if (this.hardDeleteOutcome.kind === 'force') {
                this.hardDeleteForceRequired = true;
                this.hardDeleteForce = false;
              }
              // Un 5xx puede haber dejado un intento a medias: traerlo para retomarlo.
              if (this.hardDeleteOutcome.kind === 'error') this.loadDeletionStatus(target);
            case 8:
              _context6.p = 8;
              this.hardDeleteSending = false;
              this.stopHardDeleteProgressPolling();
              if (!this.hardDeleteOutcome || this.hardDeleteOutcome.kind !== 'in_progress') {
                this.hardDeleteProgress = null;
              }
              return _context6.f(8);
            case 9:
              return _context6.a(2);
          }
        }, _callee6, this, [[4, 7, 8, 9]]);
      }));
      function confirmHardDelete() {
        return _confirmHardDelete.apply(this, arguments);
      }
      return confirmHardDelete;
    }(),
    onFormSendingChanged: function onFormSendingChanged(val) {
      // Fase 7: refleja el estado interno del form en el botón Save del dialog.
      this.formSending = !!val;
    },
    onFormErrorWithSideEffects: function onFormErrorWithSideEffects() {
      // Fase 9: si el backend pudo dejar side-effects (5xx tras stagear DB),
      // refrescar la tabla para que cualquier zombie creado sea visible al admin.
      this.fetchPage();
    },
    saveCreation: function saveCreation() {
      // Guard adicional: si ya se está enviando, no re-lanzar.
      if (this.formSending) return;
      this.$refs.createForm.submit();
    },
    buildCreatedAutomationItem: function buildCreatedAutomationItem() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = payload.result || {};
      var data = result.data || result || {};
      var request = payload.request || {};
      var automateId = data.automate_id || data.id;
      return {
        automate_id: automateId,
        status_id: 12,
        estado: 12,
        nombre_tabla: request.nombre_tabla || data.nombre_tabla || '',
        caso_de_uso: request.use_case_name || data.caso_uso || ''
      };
    },
    onSaved: function onSaved(payload) {
      this.createFormStep = 1;
      this.onCloseDialog(this.DIALOG_CREATE);
      this.fetchPage();
      this.createdAutomationItem = this.buildCreatedAutomationItem(payload);
      if (this.createdAutomationItem.automate_id) {
        this.$refs.dialogCreateSuccess.onOpen();
      } else {
        tasks.toast.success(this.$t('create_attribute.success.created'));
      }
    },
    onConfirmCreateSuccess: function onConfirmCreateSuccess(confirmed) {
      var _this18 = this;
      this.$refs.dialogCreateSuccess.onClose();
      if (confirmed && this.createdAutomationItem && this.createdAutomationItem.automate_id) {
        this.$nextTick(function () {
          _this18.openActivityTimeline(_this18.createdAutomationItem, {
            focusActive: true
          });
        });
      }
    },
    onConfirmLoadMonthsSuccess: function onConfirmLoadMonthsSuccess(confirmed) {
      var _this19 = this;
      this.$refs.dialogLoadMonthsSuccess.onClose();
      var itemToFocus = this.loadMonthsAutomationItem;
      this.loadMonthsAutomationItem = null;
      if (confirmed && itemToFocus && itemToFocus.automate_id) {
        this.$nextTick(function () {
          _this19.openActivityTimeline(itemToFocus, {
            focusActive: true
          });
        });
      }
    },
    onCloseCreate: function onCloseCreate() {
      this.createFormStep = 1;
      this.onCloseDialog(this.DIALOG_CREATE);
    },
    onPendingReview: function onPendingReview(payload) {
      // La IA de validación de particiones NO estuvo disponible (error de red/timeout):
      // el backend creó la automatización en estado "Solicitado" para revisión manual de admin.
      // Cerramos el form, refrescamos el listado (aparece la fila "Solicitado") y mostramos
      // el diálogo informativo. Si la IA encontró errores concretos, ese caso llega como 422
      // y los errores se muestran inline en el formulario (ver handler en CreateAttributeForm).
      var result = payload && payload.result || {};
      var data = result.data || result || {};
      this.sentReviewValidation = data.partition_validation || null;
      this.createFormStep = 1;
      this.onCloseDialog(this.DIALOG_CREATE);
      this.fetchPage();
      this.openDialog(this.DIALOG_SENT_TO_REVIEW);
    }
  }),
  watch: {
    'pagination.current': function paginationCurrent() {
      this.fetchPage();
    },
    'pagination.limit': function paginationLimit() {
      this.pagination.current = 1;
      this.fetchPage();
    }
  }
};